import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryGrid() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            探索内容分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">找到你最感兴趣的生活领域</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-3 p-4 md:p-5 bg-background-50 border border-background-200/60 rounded-lg hover:border-primary-200 hover:bg-primary-50/30 transition-all group cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${cat.icon} text-xl md:text-2xl w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}